import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, TextField, Button, Stack } from '@mui/material';

import { useParams } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { useToast } from '../context/ToastContext';
import { useNavigate } from 'react-router-dom';

const LoadCreditPage = () => {
  const navigate = useNavigate();
  const { showCorrect, showError } = useToast();
  const [credits, setCredits] = useState('');
  const { id, app } = useParams();
  const { postLoadCredits } = useAppContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await postLoadCredits(id , app , credits);
    navigate(`/user/${id}`);
    
  };

  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Load Credit
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Enter the amount of credits you want to load and submit the form.
          </Typography>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <TextField
                label="Credits"
                type="number"
                value={credits}
                onChange={(e) => setCredits(e.target.value)}
                fullWidth
                required
              />
              <Button variant="contained" type="submit" fullWidth>
                Load Credits
              </Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoadCreditPage;